import { Block, Flex, Grid, Typography, useModal } from '@aloft/toolkit-sui';

import { useEffect } from 'react';

import { useCarousel } from '../../hooks/useCarousel/useCarousel.ts';
import { ImageCarousel } from '../ImageCarousel/ImageCarousel.tsx';

import './ImageGallery.scss';

type ImageGalleryProps = {
  imageURLs: string[];
  address?: string;
};

const MIN_IMAGE_SIZE = 240;

const ImageGallery = ({ imageURLs, address }: ImageGalleryProps) => {
  const [selectedImageIx, selectNextImage, selectPreviousImage, selectImage] =
    useCarousel(imageURLs);
  const { Modal, closeModal, isModalOpen, openModal } = useModal();

  useEffect(() => {
    const listener = (ev: KeyboardEvent) => {
      if (ev.key === 'ArrowLeft') selectPreviousImage();
      if (ev.key === 'ArrowRight') selectNextImage();
    };

    window.addEventListener('keydown', listener);

    return () => {
      window.removeEventListener('keydown', listener);
    };
  }, [selectPreviousImage, selectNextImage]);

  return (
    <>
      {imageURLs.length ? (
        <Grid
          gridTemplateColumns={`repeat(auto-fill, minmax(max(${MIN_IMAGE_SIZE}px, calc((100% - 3rem) / 4)), 1fr))`}
          width="100%"
          gap="1rem"
          overflowY="auto"
          justifyContent="center"
        >
          {imageURLs.map((imageUrl, ix) => (
            <Flex key={`${imageUrl}-${ix}-${address}`}>
              <Block
                className="image-gallery"
                onClick={() => {
                  selectImage(ix);
                  openModal();
                }}
              >
                <img src={imageUrl} alt={`property ${ix}`} />
              </Block>
            </Flex>
          ))}
        </Grid>
      ) : (
        <Typography> No Images Found</Typography>
      )}
      <Modal size="6xl" isOpen={isModalOpen} onClose={closeModal} closeOnEsc title={address}>
        <ImageCarousel
          imageUrls={imageURLs}
          selectedImageIx={selectedImageIx}
          selectPreviousImage={selectPreviousImage}
          selectNextImage={selectNextImage}
          arrowSize="lg"
        />
      </Modal>
    </>
  );
};

export default ImageGallery;
